import
  React
from 'react';

export default ({
  size = '30',
  color = '#BD0000',
  ...props
}) => (
  <svg
    {...props}
    fill="none"
    width={size}
    height={size}
    viewBox="0 0 30 30"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      x="2"
      y="2"
      width="26"
      height="26"
      id="maskWrong0"
      // maskType="alpha"
      maskUnits="userSpaceOnUse"
    >
      <path
        fill="white"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.8749 27.35C21.7647 27.35 27.3499 21.7647 27.3499 14.875C27.3499 7.98524 21.7647 2.39999 14.8749 2.39999C7.98515 2.39999 2.3999 7.98524 2.3999 14.875C2.3999 21.7647 7.98515 27.35 14.8749 27.35ZM14.9999 16.096L18.0935 19.1896C18.445 19.5411 19.0148 19.5411 19.3663 19.1896C19.7178 18.8381 19.7178 18.2683 19.3663 17.9168L16.2727 14.8232L19.3663 11.7296C19.7178 11.3782 19.7178 10.8083 19.3663 10.4568C19.0148 10.1054 18.445 10.1054 18.0935 10.4568L14.9999 13.5504L11.9063 10.4568C11.5548 10.1054 10.985 10.1054 10.6335 10.4568C10.282 10.8083 10.282 11.3782 10.6335 11.7296L13.7271 14.8232L10.6335 17.9168C10.282 18.2683 10.282 18.8381 10.6335 19.1896C10.985 19.5411 11.5548 19.5411 11.9063 19.1896L14.9999 16.096Z"
      />
    </mask>
    <g mask="url(#maskWrong0)">
      <rect
        width="30"
        height="30"
        fill={color}
      />
    </g>
  </svg>
);